<template>
    <div class="flex items-center justify-center w-full h-full">
        <hts-card>
            <template #title>
                <p class="text-2xl text-main-500">
                    Unauthenticated!
                </p>
            </template>
            <p>
                You are attempting to access a page for registered members.<br >
                If you haven't registered before on our website, please create an account first. If you have already registered, then please login.
            </p>
            <p class="mt-2">
                <hts-link
                    :to="loginRoute"
                    class="text-lg text-main-400 hover:underline mr-2">
                    Login
                </hts-link>
                <hts-link
                    :to="registerRoute"
                    class="text-lg text-main-400 hover:underline">
                    Register
                </hts-link>
            </p>
        </hts-card>
    </div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: 'auth'
})
const loginRoute = ref('auth/login')
const registerRoute = ref('auth/register')
</script>
